module.exports = __webpack_public_path__ + "img/lv3_2_1.4a93c705.png";